/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerSendMessageMutationRequest, ResearchChatControllerSendMessageMutationResponse, ResearchChatControllerSendMessagePathParams, ResearchChatControllerSendMessage400, ResearchChatControllerSendMessage401, ResearchChatControllerSendMessage403, ResearchChatControllerSendMessage404, ResearchChatControllerSendMessage409, ResearchChatControllerSendMessage500 } from "../types/ResearchChatControllerSendMessage.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerSendMessageUrl(sessionId: ResearchChatControllerSendMessagePathParams["sessionId"]) {
  const res = { method: 'POST', url: `/api/research-chat/${sessionId}/message` as const }
  return res
}

/**
 * @description Creates a user message and initiates async AI processing. Returns immediately with the assistant message ID for polling.
 * @summary Send a message to a research chat session
 * {@link /api/research-chat/:sessionId/message}
 */
export async function researchChatControllerSendMessage(sessionId: ResearchChatControllerSendMessagePathParams["sessionId"], data: ResearchChatControllerSendMessageMutationRequest, config: Partial<RequestConfig<ResearchChatControllerSendMessageMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ResearchChatControllerSendMessageMutationResponse, ResponseErrorConfig<ResearchChatControllerSendMessage400 | ResearchChatControllerSendMessage401 | ResearchChatControllerSendMessage403 | ResearchChatControllerSendMessage404 | ResearchChatControllerSendMessage409 | ResearchChatControllerSendMessage500>, ResearchChatControllerSendMessageMutationRequest>({ method : "POST", url : getResearchChatControllerSendMessageUrl(sessionId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}